module.exports = __webpack_public_path__ + "static/img/autCt_bg_07.709168f6.svg";